import styled, { css } from "styled-components";
import { fontNormal, fontBold, fontMedium } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";
import rainLayerUrl from "../../_static/images/rma-blue-texture.png";
import ButtonDefault from "../../_atom/Buttons/default";
import Button from "../../_atom/Buttons/button";

export const OuterContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("blue", "900")};

  @media only screen and (min-width: 768px) {
    padding-top: 50px;

    &::before {
      content: "";
      background-image: url(${rainLayerUrl});
      background-repeat: no-repeat;
      background-position-x: center;
      background-size: 1280px auto;
      top: 0;
      left: 0;
      bottom: 450px;
      right: 0;
      position: absolute;
      z-index: 1;
    }
  }
`;

export const InnerContainer = styled.div`
  z-index: 2;
  background-color: ${buildColor("white", "100")};
  display: flex;
  flex-direction: column;
  padding: 12px;

  @media only screen and (max-width: 767px) {
    z-index: 0;
    margin-top: 70px;
    flex: 1;
  }

  @media only screen and (min-width: 768px) {
    width: 480px;
    align-self: center;
    padding: 24px;
    border-radius: 2px;
    margin-bottom: 48px;
  }
`;

export const MobilePageWrapper = styled.div`
  display: block;
  margin-bottom: 12px;
`;

export const InnerTitle = styled.h2`
  font-family: ${fontBold};
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 8px;
`;

export const InnerInfo = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "800")};
`;

export const DisclaimerWrapper = styled.section`
  margin-top: 28px;
`;

export const DisclaimerText = styled.p`
  display: flex;
  align-items: center;
  font-family: ${fontNormal};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${buildColor("grey", "800")};
  margin-bottom: 8px;

  svg {
    margin-right: 4px;
  }

  & a {
    font-family: ${fontMedium};
    color: ${buildColor("grey", "800")};
  }
`;

export const LegalContentButton = styled(ButtonDefault)`
  font-family: ${fontMedium};
  color: ${buildColor("grey", "800")};
  font-size: 12px;
  text-decoration: underline;
  vertical-align: baseline;
`;

export const ReviewSubmitButton = styled(Button)`
  ${({ showDisabled }) =>
    showDisabled &&
    css`
      opacity: 0.5;
    `}
`;
